'use client';

import { usePromoCode } from '@/hooks/use-promo-code';

export function PromoCodeBanner() {
  const { code, hasDiscount, pricing } = usePromoCode();

  return code ? (
    <div className='flex justify-center bg-secondary/75 p-1 w-full'>
      <span className='text-secondary-foreground'>
        Promo code activated: {code}
        {hasDiscount ? <>&nbsp;&nbsp;→&nbsp;&nbsp;{pricing.percentage}% off</> : null}
      </span>
    </div>
  ) : null;
}
